"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _BaseFeatureWidget = require("./BaseFeatureWidget");

var _Plugin2 = _interopRequireDefault(require("./Plugin"));

var _AdapterType = _interopRequireDefault(require("@jbrowse/core/pluggableElementTypes/AdapterType"));

var coreRpcMethods = _interopRequireWildcard(require("./rpc/coreRpcMethods"));

var _WidgetType = _interopRequireDefault(require("./pluggableElementTypes/WidgetType"));

var _CytobandAdapter = require("./data_adapters/CytobandAdapter");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// the core plugin, which registers types that ALL JBrowse applications are
// expected to need.
var CorePlugin = /*#__PURE__*/function (_Plugin) {
  (0, _inherits2.default)(CorePlugin, _Plugin);

  var _super = _createSuper(CorePlugin);

  function CorePlugin() {
    var _this;

    (0, _classCallCheck2.default)(this, CorePlugin);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "name", 'CorePlugin');
    return _this;
  }

  (0, _createClass2.default)(CorePlugin, [{
    key: "install",
    value: function install(pluginManager) {
      // register all our core rpc methods
      Object.values(coreRpcMethods).forEach(function (RpcMethod) {
        pluginManager.addRpcMethod(function () {
          return new RpcMethod(pluginManager);
        });
      });
      pluginManager.addAdapterType(function () {
        return new _AdapterType.default({
          name: 'CytobandAdapter',
          configSchema: _CytobandAdapter.configSchema,
          AdapterClass: _CytobandAdapter.DataAdapter
        });
      });
      pluginManager.addWidgetType(function () {
        return new _WidgetType.default({
          name: 'BaseFeatureWidget',
          heading: 'Feature details',
          configSchema: _BaseFeatureWidget.configSchema,
          stateModel: (0, _BaseFeatureWidget.stateModelFactory)(pluginManager),
          ReactComponent: /*#__PURE__*/(0, _react.lazy)(function () {
            return Promise.resolve().then(function () {
              return _interopRequireWildcard(require('./BaseFeatureWidget/BaseFeatureDetail'));
            });
          })
        });
      });
    }
  }]);
  return CorePlugin;
}(_Plugin2.default);

exports.default = CorePlugin;